export const DATA_LOCALSTORAGE = {
  COUNTRY: '_country',
  CODE_ALLY: '_ally_code',
  TOKEN: '_token',
  USER_ACCESS: '_user_access',
  SHOP_MODE: '_shop_mode'
}
